if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}

			this.updateDeliveryPromise(variant);
		}

		updateDeliveryPromise(variant) {
			const block = this.querySelector('[data-delivery-promise]');
			if (!block) return;

			// IMPORTANT: Shopify's {{ variant | json }} does NOT serialize inventory_quantity
			// or inventory_policy. Read authoritative values from [data-js-variant-quantity-data]
			// which Liquid populates correctly via a separate data structure.
			// FAIL-SAFE: if quantity data is missing or unparseable, return without touching
			// the DOM — preserving the server-rendered Liquid state rather than inventing state.
			let state;

			if (!variant) return;

			if (!variant.inventory_management) {
				// Untracked: inventory_management is null — available is the only reliable signal
				// and IS present in the variant JSON. Handle without quantity-data.
				state = variant.available ? 'untracked' : 'out_of_stock';
			} else {
				// Tracked: read quantity and policy from [data-js-variant-quantity-data].
				const qtyEl = this.querySelector('[data-js-variant-quantity-data]');
				if (!qtyEl) return; // fail-safe: preserve Liquid state

				let entry = null;
				try {
					const qtyData = JSON.parse(qtyEl.dataset.inventory || '[]');
					entry = qtyData.find(function(e) { return e.id === variant.id; });
				} catch (err) {}

				if (!entry) return; // fail-safe: preserve Liquid state

				const inventoryQuantity = entry.quantity;
				const inventoryPolicy   = entry.inventory; // "continue" | "deny"

				if (inventoryQuantity > 0) {
					state = 'in_stock';
				} else if (inventoryPolicy === 'continue') {
					state = 'continue_selling';
				} else if (variant.available) {
					// qty<=0, policy=deny, Shopify says purchasable → stock at online-enabled location
					state = 'in_stock';
				} else {
					state = 'out_of_stock';
				}
			}

			// Swap modifier class
			['in-stock', 'continue-selling', 'out-of-stock', 'untracked'].forEach(function(s) {
				block.classList.remove('gilgal-delivery-promise--' + s);
			});
			block.classList.add('gilgal-delivery-promise--' + state.replace(/_/g, '-'));

			const svgCheck = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
			const svgClock = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
			const svgInfo  = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

			// Stock line
			const stockLine = block.querySelector('[data-dp-stock-line]');
			if (stockLine && block.dataset.dpShowStock !== 'false') {
				const textMap = {
					in_stock:         block.dataset.dpInStockText,
					continue_selling: block.dataset.dpContinueSellingText,
					out_of_stock:     block.dataset.dpOutOfStockText,
					untracked:        block.dataset.dpUntrackedText
				};
				const iconMap = {
					in_stock:         svgCheck,
					continue_selling: svgClock,
					out_of_stock:     svgInfo,
					untracked:        svgCheck
				};
				const text = textMap[state] || '';
				if (text) {
					stockLine.innerHTML = iconMap[state] + '<span data-dp-stock-text>' + text + '</span>';
					stockLine.style.display = '';
				} else {
					stockLine.style.display = 'none';
				}
			}

			// Shipping line
			const shippingLine = block.querySelector('[data-dp-shipping-line]');
			if (shippingLine && block.dataset.dpShowShipping !== 'false') {
				const shippingMap = {
					in_stock:         block.dataset.dpInStockShipping,
					continue_selling: block.dataset.dpContinueSellingShipping,
					out_of_stock:     block.dataset.dpOutOfStockShipping,
					untracked:        block.dataset.dpUntrackedShipping
				};
				const text = shippingMap[state] || '';
				const span = shippingLine.querySelector('[data-dp-shipping-text]');
				if (text) {
					if (span) span.textContent = text;
					shippingLine.style.display = '';
				} else {
					shippingLine.style.display = 'none';
				}
			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}